module.exports = __webpack_public_path__ + "assets/e9aa8f6ac8808253dc73f1c7d2d7e567.mp3";